import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_ESTUDIANTES,
  ALL_ESTUDIANTES,
  ALL_ESTUDIANTES_DOCENTE,
  ALL_ESTUDIANTES_NOTAS,
  ASISTENCIAS_DIARIAS_ESTUDIANTE,
  LOADING_ALL_ESTUDIANTES,
  NOTAS_EVALUATIVAS_ESTUDIANTE,
  PARAMS_ESTUDIANTES,
} from './EstudiantesReducer';
import {
  allEstudiantesDocenteAdminService,
  allEstudiantesDocenteService,
  allEstudiantesNotasEvaluativasService,
  allEstudiantesService,
  asistenciasDiariasEstudianteService,
  notasEvaluativasEstudianteService,
  oneEstudiantesService,
  updateEstatusEstudianteService,
} from './EstudiantesService';

export const allEstudiantesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: true });
    dispatch({
      type: PARAMS_ESTUDIANTES,
      payload: {
        idDocente: null,
        idPeriodoAcademico: null,
        ...params,
      },
    });
    const res = await allEstudiantesService(params);
    dispatch({ type: ALL_ESTUDIANTES, payload: res.data });
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const setActivoEstudiantesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ESTUDIANTES, payload: data });
};

export const oneEstudiantesAction = async (dispatch, id) => {
  try {
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: true });
    const res = await oneEstudiantesService(id);
    await setActivoEstudiantesAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const notasEvaluativasEstudianteAction = async (
  dispatch,
  id,
  params,
) => {
  try {
    const res = await notasEvaluativasEstudianteService(id, params);
    dispatch({
      type: NOTAS_EVALUATIVAS_ESTUDIANTE,
      payload: res.data.data ?? [],
    });
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const asistenciasDiariasEstudianteAction = async (
  dispatch,
  id,
  params,
) => {
  try {
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: true });
    const res = await asistenciasDiariasEstudianteService(id, params);
    dispatch({
      type: ASISTENCIAS_DIARIAS_ESTUDIANTE,
      payload: res.data.data ?? [],
    });
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: false });
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const allEstudiantesDocenteAction = async (
  isAdminTeacher,
  dispatch,
  idDocente,
  params,
) => {
  try {
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: true });
    let res;
    if (isAdminTeacher) {
      res = await allEstudiantesDocenteAdminService(idDocente, params);
    } else {
      res = await allEstudiantesDocenteService(idDocente, params);
    }
    dispatch({
      type: ALL_ESTUDIANTES_DOCENTE,
      payload: res.data.data ?? [],
    });
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: false });
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const allEstudiantesNotasEvaluativasAction = async (
  dispatch,
  params,
) => {
  try {
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: true });
    const res = await allEstudiantesNotasEvaluativasService(params);
    dispatch({
      type: ALL_ESTUDIANTES_NOTAS,
      payload: res.data.data,
    });
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: false });
    return res.data.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ESTUDIANTES, payload: false });
    tryCatchHelper(e);
  }
};

export const updateEstatusEstudianteAction = async (
  { dispatch, notify },
  data,
  params,
) => {
  try {
    const res = await updateEstatusEstudianteService(data);
    notify(res.data.message);
    await allEstudiantesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
